/* SEO-draft #20: add a suggested product from the cart popup / drawer / cart page, then refresh in place. */
(function () {
  if (window.dlCartExtras) return;
  window.dlCartExtras = true;

  function sectionHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector || '.shopify-section');
    return el ? el.innerHTML : null;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-dl-add]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    btn.setAttribute('aria-busy', 'true');

    var drawer = document.querySelector('cart-drawer');
    var notification = document.getElementById('dl-cart-extras');
    var onCartPage = !!document.getElementById('main-cart-items');
    var sections = [];
    if (drawer && !onCartPage) sections = ['cart-drawer', 'cart-icon-bubble'];
    else if (notification && !onCartPage) sections = ['dl-cart-extras', 'cart-icon-bubble', 'cart-notification-button'];

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(btn.getAttribute('data-dl-add')), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) { btn.removeAttribute('aria-busy'); return; }
        if (onCartPage) { window.location.reload(); return; }
        if (drawer && state.sections && state.sections['cart-drawer']) {
          drawer.classList.remove('is-empty');
          var inner = sectionHTML(state.sections['cart-drawer'], '.drawer__inner');
          var target = drawer.querySelector('.drawer__inner');
          if (inner !== null && target) target.innerHTML = inner;
        }
        if (state.sections) {
          ['dl-cart-extras', 'cart-icon-bubble', 'cart-notification-button'].forEach(function (id) {
            var el = document.getElementById(id);
            if (el && state.sections[id]) {
              var html = sectionHTML(state.sections[id]);
              if (html !== null) el.innerHTML = html;
            }
          });
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'dl-cart-extras', cartData: state });
        }
      })
      .catch(function () { btn.removeAttribute('aria-busy'); });
  });
})();
